import template from './complaintsRegister.html';
import controller from './complaintsRegisterCtrl';
import './style.scss';

export default {
  template,
  controller,
  controllerAs: 'vm',
};
